function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Group_32442",
  "data-name": "Group 32442",
  transform: "translate(-16 -16)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_5651",
  "data-name": "Rectangle 5651",
  width: 32,
  height: 32,
  transform: "translate(16 16)",
  fill: "#f5f5f7"
}), /*#__PURE__*/React.createElement("path", {
  id: "np_company_637100_000000",
  d: "M32.635,28.74c-1.25-.375-3.249-1-3.875-1.125-.125,0-.125-.125-.125-.25V19.616c0-.25,0-.375-.25-.5l-4-2.5a1.1,1.1,0,0,0-.75-.25,1.052,1.052,0,0,0-.75.25c-.875.749-4,2.623-4,2.623a.653.653,0,0,0-.25.5v7.75c0,.125,0,.125-.125.25-.5.125-2.375.624-3.624,1-1.125.25-1.25.875-1.25,1.375v4.249a1.121,1.121,0,0,0,1.25,1.25h17.5c1.25,0,1.25-1,1.25-1.75v-3.75a1.51,1.51,0,0,0-1-1.375Zm-9,5.125a.537.537,0,0,1-.5.5h-2.75a.537.537,0,0,1-.5-.5V19.991c0-.125.125-.25.25-.375l3-1.625c.125-.125.625,0,.625.25V33.865Zm8.749-.25c0,.25-.125.5-.5.375l-2.625-.75c-.5-.125-.624-.25-.624-.625V31.99c0-.375.25-.5.625-.375l2.75.875c.25.125.375.25.375.75Zm0-2.75c0,.25-.125.5-.5.375l-2.75-.624c-.375-.125-.5-.25-.5-.625v-.625c0-.375.25-.5.625-.375l2.75.875c.25.125.375.25.375.75Z",
  transform: "translate(8.363 6.01)",
  fill: "#130f35",
  opacity: 0.12
}));

function SvgUnknownCompany(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnknownCompany);
export default __webpack_public_path__ + "static/media/unknown_company.0b626a84.svg";
export { ForwardRef as ReactComponent };